import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import config from "../../baseConfig/index";
import { trans } from "../../helpers/index";
import { setTranslationsAction } from "../../store/Layout/actions";

function NotFoundView(props) {
  const [picToUpClass, setPicToUpClass] = useState("");

  useEffect(() => {
    // Replicates 'componentWillMount' + the setTimeout logic in 'componentDidMount'
    const timeoutId = setTimeout(() => {
      setPicToUpClass(" error-page__inner-pic--start");
    }, 5000);

    // Cleanup timer on unmount (equivalent to componentWillUnmount)
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div className="error-page tc">
      <div className="container">
        <h2 className="error-page__title fs64 tu">
          {trans(props.trans, "error.page.title")}
        </h2>
        <div className="error-page__pic-box pr">
          <div className="error-page__hidden-box">
            <div className={`error-page__inner-pic${picToUpClass}`}></div>
          </div>
        </div>
        <p className="error-page__status fs40 tu">
          {trans(props.trans, "error.page.status")}
        </p>
        <Link
          className="btn btn--yellow ver-top-box trans-background"
          to={config.urlPrefix}
        >
          {trans(props.trans, "error.page.link_title")}
        </Link>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    trans: state.layout.trans,
  };
};

const mapDispatchToProps = {
  setTranslationsAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(NotFoundView);
